(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (Number.isNaN(number) || number == null) {
        return '0';
      }

      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch ((formatString.match(placeholderRegex) || [])[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function syncFixedBars() {
    var announcement = document.querySelector('[data-announcement]');
    var header = document.querySelector('[data-site-header]');
    document.documentElement.style.setProperty('--fixed-announcement-height', (announcement ? announcement.offsetHeight : 0) + 'px');
    document.documentElement.style.setProperty('--fixed-header-height', (header ? header.offsetHeight : 0) + 'px');
  }

  function initHeader(header) {
    if (header.dataset.headerInitialized === 'true') return;
    header.dataset.headerInitialized = 'true';

    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchPanel = header.querySelector('[data-search-panel]');
    var mobileToggle = header.querySelector('[data-mobile-toggle]');
    var mobileDrawer = header.querySelector('[data-mobile-drawer]');
    var mobileCloseButtons = header.querySelectorAll('[data-mobile-close]');

    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        var open = searchPanel.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', String(open));
        if (open) {
          var input = searchPanel.querySelector('input[type="search"]');
          if (input) input.focus();
        }
        window.requestAnimationFrame(syncFixedBars);
      });
    }

    if (mobileToggle && mobileDrawer) {
      function setDrawer(open) {
        mobileDrawer.classList.toggle('is-open', open);
        mobileToggle.setAttribute('aria-expanded', String(open));
        document.documentElement.classList.toggle('drawer-open', open);
      }

      mobileToggle.addEventListener('click', function () {
        setDrawer(!mobileDrawer.classList.contains('is-open'));
      });

      mobileCloseButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setDrawer(false);
        });
      });

      mobileDrawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setDrawer(false);
        });
      });
    }

    window.addEventListener('resize', syncFixedBars);
    window.requestAnimationFrame(syncFixedBars);
  }

  function initAnnouncements(root) {
    if (root.dataset.announcementInitialized === 'true') {
      syncFixedBars();
      return;
    }
    root.dataset.announcementInitialized = 'true';

    var slides = root.querySelectorAll('[data-announcement-slide]');
    if (slides.length < 2) {
      syncFixedBars();
      return;
    }

    var index = 0;
    window.setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
      syncFixedBars();
    }, 4000);

    syncFixedBars();
  }

  function initHomeSlideshows(root) {
    root.querySelectorAll('[data-home-slideshow]').forEach(function (slideshow) {
      if (slideshow.dataset.homeSlideshowInitialized === 'true') return;
      slideshow.dataset.homeSlideshowInitialized = 'true';

      var slides = slideshow.querySelectorAll('[data-home-slide]');
      var dots = slideshow.querySelectorAll('[data-home-slide-dot]');
      var index = 0;
      var timer = null;
      if (slides.length < 2) return;

      function showSlide(nextIndex) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = nextIndex;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
      }

      function startAutoplay() {
        if (slideshow.getAttribute('data-home-slideshow-autoplay') !== 'true') return;
        var interval = Math.max(3000, Number(slideshow.getAttribute('data-home-slideshow-interval')) || 5000);
        window.clearInterval(timer);
        timer = window.setInterval(function () {
          showSlide((index + 1) % slides.length);
        }, interval);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          showSlide(Number(dot.getAttribute('data-home-slide-dot')) || 0);
          startAutoplay();
        });
      });

      slideshow.addEventListener('mouseenter', function () { window.clearInterval(timer); });
      slideshow.addEventListener('mouseleave', startAutoplay);
      startAutoplay();
    });
  }

  function initSliders(root) {
    root.querySelectorAll('[data-product-slider]').forEach(function (slider) {
      if (slider.dataset.sliderInitialized === 'true') return;
      slider.dataset.sliderInitialized = 'true';

      var track = slider.querySelector('[data-product-slider-track]');
      if (!track) return;
      var autoplayTimer = null;
      var paused = false;
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function getScrollStep() {
        var firstCard = track.querySelector('.product-card');
        if (!firstCard) return Math.max(280, track.clientWidth * 0.8);

        var trackStyle = window.getComputedStyle(track);
        var gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 16;
        return firstCard.getBoundingClientRect().width + gap;
      }

      function hasOverflow() {
        return track.scrollWidth > track.clientWidth + 2;
      }

      function scrollSlider(direction) {
        if (!hasOverflow()) return;

        var maxScroll = track.scrollWidth - track.clientWidth;
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= maxScroll - 2;

        if (direction > 0 && atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }

        if (direction < 0 && atStart) {
          track.scrollTo({ left: maxScroll, behavior: 'smooth' });
          return;
        }

        track.scrollBy({ left: direction * getScrollStep(), behavior: 'smooth' });
      }

      function startAutoplay() {
        var autoplayEnabled = slider.getAttribute('data-slider-autoplay') === 'true';
        var interval = Math.max(2000, Number(slider.getAttribute('data-slider-interval')) || 4000);

        if (!autoplayEnabled || prefersReducedMotion || !hasOverflow()) return;

        window.clearInterval(autoplayTimer);
        autoplayTimer = window.setInterval(function () {
          if (paused || slider.contains(document.activeElement)) return;
          scrollSlider(1);
        }, interval);
      }

      function restartAutoplay() {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
        startAutoplay();
      }

      slider.querySelectorAll('[data-slider-direction]').forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = button.getAttribute('data-slider-direction') === 'next' ? 1 : -1;
          scrollSlider(direction);
          restartAutoplay();
        });
      });

      slider.addEventListener('mouseenter', function () {
        paused = true;
      });

      slider.addEventListener('mouseleave', function () {
        paused = false;
      });

      slider.addEventListener('focusin', function () {
        paused = true;
      });

      slider.addEventListener('focusout', function () {
        paused = false;
      });

      slider.addEventListener('touchstart', function () {
        paused = true;
      }, { passive: true });

      slider.addEventListener('touchend', function () {
        window.setTimeout(function () {
          paused = false;
        }, 1600);
      }, { passive: true });

      window.addEventListener('resize', restartAutoplay);
      window.addEventListener('load', restartAutoplay);
      startAutoplay();
      window.setTimeout(startAutoplay, 800);
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;

      gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(function (button) {
        button.addEventListener('click', function () {
          var image = button.querySelector('img');
          if (!image) return;

          main.src = button.getAttribute('data-full-src') || image.src;
          main.alt = image.alt || main.alt;
          gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(function (item) {
            item.classList.remove('is-active');
          });
          button.classList.add('is-active');
        });
      });
    });
  }

  function initQuantity(root) {
    root.querySelectorAll('[data-quantity]').forEach(function (quantity) {
      var input = quantity.querySelector('input[type="number"]');
      if (!input) return;

      quantity.querySelectorAll('[data-quantity-change]').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = Number(button.getAttribute('data-quantity-change'));
          var min = Number(input.getAttribute('min')) || 1;
          var next = Math.max(min, (Number(input.value) || min) + step);
          input.value = String(next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function replaceTemplate(template, values) {
    return String(template || '').replace(/\{\{\s*(quantity|percent|count)\s*\}\}|\[\s*(quantity|percent|count)\s*\]/g, function (_, liquidKey, bracketKey) {
      var key = liquidKey || bracketKey;
      return values[key] == null ? '' : values[key];
    });
  }

  function routeWithJson(route) {
    if (!route) return '';
    return route.indexOf('.js') > -1 ? route : route + '.js';
  }

  function getCartRoutes() {
    return window.ConsensutsTheme && window.ConsensutsTheme.routes ? window.ConsensutsTheme.routes : {};
  }

  function fetchCart() {
    var routes = getCartRoutes();
    if (!routes.cart) return Promise.reject(new Error('Cart route is missing.'));

    return fetch(routeWithJson(routes.cart), {
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed.');
      return response.json();
    });
  }

  function updateCartCount(cart) {
    if (!cart) return;

    document.querySelectorAll('.cart-count').forEach(function (count) {
      count.textContent = cart.item_count;
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function getCartTierMessage(cart) {
    var config = window.ConsensutsTheme && window.ConsensutsTheme.cartTierMessages;
    if (!config || config.enabled === false || !cart || cart.item_count < 1) return '';

    if (cart.item_count >= 4) return config.unlocked || '';
    if (cart.item_count >= 3) return config.next15 || '';
    if (cart.item_count >= 2) return config.next10 || '';
    return config.next5 || '';
  }

  function updateCartTierPrompts(cart) {
    var message = getCartTierMessage(cart);

    document.querySelectorAll('[data-cart-tier-prompt]').forEach(function (prompt) {
      prompt.textContent = message;
      prompt.hidden = !message;
    });
  }

  function getCartSubtotalPrice(cart) {
    if (!cart) return 0;
    if (cart.original_total_price != null) return cart.original_total_price;
    if (cart.items_subtotal_price != null) return cart.items_subtotal_price;
    return cart.total_price || 0;
  }

  function getCartDiscountValue(cart) {
    return cart ? Number(cart.total_discount) || 0 : 0;
  }

  function normalizeCartItemImage(url) {
    if (!url) return '';
    return url.indexOf('//') === 0 ? window.location.protocol + url : url;
  }

  function getCartItemOptions(item) {
    if (Array.isArray(item.options_with_values)) {
      return item.options_with_values
        .filter(function (option) {
          return option && option.value && option.value !== 'Default Title';
        })
        .map(function (option) {
          return option.value;
        });
    }

    if (item.variant_title && item.variant_title !== 'Default Title') {
      return [item.variant_title];
    }

    return [];
  }

  function initProductForms(root) {
    root.querySelectorAll('[data-product-form]').forEach(function (container) {
      var productJson = container.querySelector('[data-product-json]');
      var inventoryJson = container.querySelector('[data-product-inventory-json]');
      var form = container.querySelector('form[action*="/cart/add"]');
      if (!productJson || !form) return;

      var product = JSON.parse(productJson.textContent);
      var inventoryByVariant = {};
      if (inventoryJson) {
        JSON.parse(inventoryJson.textContent).forEach(function (inventory) {
          inventoryByVariant[String(inventory.id)] = inventory;
        });
      }
      var variantInput = form.querySelector('[name="id"]');
      var submitButton = form.querySelector('[name="add"]');
      var priceContainer = container.querySelector('[data-product-price]');
      var status = container.querySelector('[data-product-status]');
      var urgency = container.querySelector('[data-inventory-urgency]');
      var urgencyBar = container.querySelector('[data-inventory-bar]');
      var urgencyMessage = container.querySelector('[data-inventory-message]');
      var optionGroups = Array.from(container.querySelectorAll('[data-option-position]'));

      function getSelectedOptions() {
        return optionGroups.map(function (group) {
          var checked = group.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : null;
        });
      }

      function findVariant(options, availableOnly) {
        return product.variants.find(function (variant) {
          if (availableOnly && !variant.available) return false;
          return options.every(function (value, index) {
            return !value || variant.options[index] === value;
          });
        });
      }

      function setSelectedVariant(variant) {
        if (!variant) return;

        optionGroups.forEach(function (group, index) {
          var input = group.querySelector('input[value="' + CSS.escape(variant.options[index]) + '"]');
          if (input) input.checked = true;
        });
      }

      function updateAvailability() {
        var selected = getSelectedOptions();

        optionGroups.forEach(function (group, groupIndex) {
          group.querySelectorAll('input[type="radio"]').forEach(function (input) {
            var candidate = selected.slice();
            candidate[groupIndex] = input.value;
            var available = Boolean(findVariant(candidate, true));
            input.disabled = !available;
          });
        });
      }

      function updateState() {
        var selected = getSelectedOptions();
        var variant = findVariant(selected, false);

        if (!variant || !variant.available) {
          variant = findVariant(selected, true) || product.variants.find(function (item) {
            return item.available;
          }) || product.variants[0];
          setSelectedVariant(variant);
        }

        updateAvailability();

        if (variantInput && variant) {
          variantInput.value = variant.id;
        }

        if (priceContainer && variant) {
          var compare = variant.compare_at_price;
          var price = formatMoney(variant.price, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat);
          var compareHtml = compare && compare > variant.price
            ? '<span class="price__compare">' + formatMoney(compare, window.ConsensutsTheme.moneyFormat) + '</span>'
            : '';
          priceContainer.innerHTML = '<span class="price__sale">' + price + '</span>' + compareHtml;
        }

        if (submitButton) {
          var purchasable = Boolean(variant && variant.available);
          submitButton.disabled = !purchasable;
          submitButton.textContent = purchasable ? submitButton.getAttribute('data-add-text') : submitButton.getAttribute('data-sold-out-text');
        }

        if (status) {
          var isAvailable = Boolean(variant && variant.available);
          status.classList.toggle('is-unavailable', !isAvailable);
          status.querySelector('strong').textContent = isAvailable
            ? status.getAttribute('data-in-stock-text')
            : status.getAttribute('data-sold-out-text');
        }

        if (urgency && variant) {
          var threshold = Number(urgency.getAttribute('data-threshold')) || 10;
          var inventory = inventoryByVariant[String(variant.id)] || {};
          var tracked = Boolean(inventory.inventory_management);
          var quantity = Number(inventory.inventory_quantity);
          var percent = 0;
          var visible = false;
          var template = urgency.getAttribute('data-tracked-template');

          if (tracked && quantity > 0 && quantity <= threshold) {
            visible = true;
            percent = Math.max(1, Math.round((quantity / threshold) * 100));
          }

          urgency.classList.toggle('is-hidden', !visible);
          if (urgencyBar) urgencyBar.style.width = Math.min(100, Math.max(1, percent)) + '%';
          if (urgencyMessage) {
            urgencyMessage.innerHTML = replaceTemplate(template, {
              quantity: '<strong>' + quantity + '</strong>'
            });
          }
        }

        document.dispatchEvent(new CustomEvent('consensuts:variant-change', {
          detail: {
            productId: product.id,
            variant: variant
          }
        }));
      }

      optionGroups.forEach(function (group) {
        group.addEventListener('change', updateState);
      });

      updateState();
    });
  }

  function initVisitorBadges(root) {
    root.querySelectorAll('[data-visitor-badge]').forEach(function (badge) {
      var min = Number(badge.getAttribute('data-min')) || 1;
      var max = Number(badge.getAttribute('data-max')) || min;
      var count = min + Math.floor(Math.random() * (Math.max(min, max) - min + 1));
      var target = badge.querySelector('[data-visitor-text]');
      if (target) {
        target.textContent = replaceTemplate(badge.getAttribute('data-template'), { count: count });
      }
    });
  }

  function initStickyATC(root) {
    root.querySelectorAll('[data-sticky-atc]').forEach(function (bar) {
      var productJson = bar.querySelector('[data-sticky-product-json]');
      var variantInput = bar.querySelector('[data-sticky-variant-id]');
      var price = bar.querySelector('[data-sticky-price]');
      var variantTitle = bar.querySelector('[data-sticky-variant-title]');
      var button = bar.querySelector('[name="add"]');
      var buttonText = bar.querySelector('[data-sticky-button-text]');
      var threshold = Number(bar.getAttribute('data-threshold')) || 520;
      if (!productJson || !variantInput || !button) return;

      var product = JSON.parse(productJson.textContent);

      function setVisible() {
        bar.classList.toggle('is-visible', window.scrollY > threshold);
      }

      function updateVariant(variant) {
        if (!variant) return;
        variantInput.value = variant.id;
        if (price) {
          var compare = variant.compare_at_price;
          var compareHtml = compare && compare > variant.price
            ? '<span class="price__compare">' + formatMoney(compare, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat) + '</span>'
            : '';
          price.innerHTML = '<span class="price__sale">' + formatMoney(variant.price, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat) + '</span>' + compareHtml;
        }
        if (variantTitle) {
          variantTitle.textContent = product.has_only_default_variant ? '' : variant.title;
        }
        button.disabled = !variant.available;
        if (buttonText) {
          buttonText.textContent = variant.available ? button.getAttribute('data-add-text') : button.getAttribute('data-sold-out-text');
        }
      }

      window.addEventListener('scroll', setVisible, { passive: true });
      window.addEventListener('resize', setVisible);
      document.addEventListener('consensuts:variant-change', function (event) {
        if (!event.detail || String(event.detail.productId) !== String(product.id)) return;
        updateVariant(event.detail.variant);
      });
      setVisible();
    });
  }

  function initQuickView() {
    if (document.documentElement.dataset.quickViewInitialized === 'true') return;

    var modal = document.querySelector('[data-quick-view-modal]');
    if (!modal) return;

    document.documentElement.dataset.quickViewInitialized = 'true';

    var dialog = modal.querySelector('[data-quick-view-dialog]');
    var title = modal.querySelector('[data-quick-view-title]');
    var price = modal.querySelector('[data-quick-view-price]');
    var mainImage = modal.querySelector('[data-quick-view-image]');
    var emptyImage = modal.querySelector('[data-quick-view-image-empty]');
    var form = modal.querySelector('[data-quick-view-form]');
    var variantInput = modal.querySelector('[data-quick-view-variant-id]');
    var quantityInput = modal.querySelector('[data-quick-view-quantity]');
    var optionsContainer = modal.querySelector('[data-quick-view-options]');
    var submitButton = modal.querySelector('[data-quick-view-submit]');
    var submitText = modal.querySelector('[data-quick-view-submit-text]');
    var status = modal.querySelector('[data-quick-view-status]');
    var detailsLink = modal.querySelector('[data-quick-view-details-link]');

    var currentProduct = null;
    var selectedOptions = [];
    var activeVariant = null;
    var activeElement = null;
    var imageList = [];

    function normalizeImageUrl(image) {
      if (!image) return '';

      var url = '';

      if (typeof image === 'string') {
        url = image;
      } else {
        url = image.src || image.url || (image.preview_image && normalizeImageUrl(image.preview_image)) || '';
      }

      if (url.indexOf('//') === 0) {
        return window.location.protocol + url;
      }

      return url;
    }

    function getVariantImageUrl(variant) {
      return normalizeImageUrl(variant && variant.featured_image) ||
        normalizeImageUrl(currentProduct && currentProduct.featured_image) ||
        imageList[0] ||
        '';
    }

    function setMainImage(url, alt) {
      if (url) {
        mainImage.src = url;
        mainImage.alt = alt || '';
        mainImage.hidden = false;
        emptyImage.hidden = true;
      } else {
        mainImage.removeAttribute('src');
        mainImage.alt = '';
        mainImage.hidden = true;
        emptyImage.hidden = false;
      }
    }

    function getVariants() {
      return currentProduct && Array.isArray(currentProduct.variants) ? currentProduct.variants : [];
    }

    function getFirstPurchasableVariant(product) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      return variants.find(function (variant) {
        return variant.available;
      }) || variants[0] || null;
    }

    function appendVariantToUrl(url, variant) {
      if (!url || !variant) return url || '#';
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + 'variant=' + encodeURIComponent(variant.id);
    }

    function hasSelectableOptions(product) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var firstVariant = variants[0];

      if (!firstVariant) return false;
      if (variants.length > 1) return true;

      return !(
        firstVariant.title === 'Default Title' ||
        (Array.isArray(firstVariant.options) && firstVariant.options.length === 1 && firstVariant.options[0] === 'Default Title')
      );
    }

    function getOptionGroups(product) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var names = Array.isArray(product.options) ? product.options.map(function (option, index) {
        if (typeof option === 'string') return option;
        return option && option.name ? option.name : 'Option ' + (index + 1);
      }) : [];
      var optionCount = 0;

      variants.forEach(function (variant) {
        optionCount = Math.max(optionCount, Array.isArray(variant.options) ? variant.options.length : 0);
      });

      while (names.length < optionCount) {
        names.push('Option ' + (names.length + 1));
      }

      return names.slice(0, optionCount).map(function (name, index) {
        var values = [];

        variants.forEach(function (variant) {
          var value = Array.isArray(variant.options) ? variant.options[index] : null;
          if (value && values.indexOf(value) === -1) {
            values.push(value);
          }
        });

        return {
          index: index,
          name: name,
          values: values
        };
      });
    }

    function findVariant(options, availableOnly) {
      return getVariants().find(function (variant) {
        if (availableOnly && !variant.available) return false;

        return options.every(function (value, index) {
          var variantOptions = Array.isArray(variant.options) ? variant.options : [];
          return !value || variantOptions[index] === value;
        });
      });
    }

    function syncSelectedOptions(variant) {
      selectedOptions = variant && Array.isArray(variant.options) ? variant.options.slice() : [];

      optionsContainer.querySelectorAll('[data-quick-view-option]').forEach(function (input) {
        var index = Number(input.getAttribute('data-option-index'));
        input.checked = selectedOptions[index] === input.value;
      });
    }

    function updateOptionAvailability() {
      optionsContainer.querySelectorAll('[data-quick-view-option-group]').forEach(function (group) {
        var groupIndex = Number(group.getAttribute('data-option-index'));

        group.querySelectorAll('[data-quick-view-option]').forEach(function (input) {
          var candidate = selectedOptions.slice();
          candidate[groupIndex] = input.value;
          input.disabled = !Boolean(findVariant(candidate, true));
        });
      });
    }

    function updatePrice(variant) {
      if (!price || !variant) return;

      var compare = variant.compare_at_price;
      var compareHtml = compare && compare > variant.price
        ? '<span class="price__compare">' + formatMoney(compare, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat) + '</span>'
        : '';

      price.innerHTML = '<span class="price__sale">' + formatMoney(variant.price, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat) + '</span>' + compareHtml;
    }

    function updateState() {
      var variant = findVariant(selectedOptions, false);

      if (!variant || !variant.available) {
        variant = findVariant(selectedOptions, true) || getFirstPurchasableVariant(currentProduct);
        syncSelectedOptions(variant);
      }

      activeVariant = variant;
      updateOptionAvailability();

      if (variantInput && variant) {
        variantInput.value = variant.id;
      }

      updatePrice(variant);
      setMainImage(getVariantImageUrl(variant), currentProduct && currentProduct.title);

      if (detailsLink) {
        detailsLink.href = appendVariantToUrl(currentProduct && currentProduct.url, variant);
      }

      if (submitButton && submitText) {
        var purchasable = Boolean(variant && variant.available);
        submitButton.disabled = !purchasable;
        submitText.textContent = purchasable ? submitButton.getAttribute('data-add-text') : submitButton.getAttribute('data-sold-out-text');
      }
    }

    function renderImages(product, variant) {
      imageList = [];

      function addImage(image) {
        var url = normalizeImageUrl(image);
        if (url && imageList.indexOf(url) === -1) {
          imageList.push(url);
        }
      }

      addImage(variant && variant.featured_image);
      addImage(product.featured_image);

      if (Array.isArray(product.images)) {
        product.images.forEach(addImage);
      }

      getVariants().forEach(function (item) {
        addImage(item.featured_image);
      });

      setMainImage(getVariantImageUrl(variant), product.title || '');
    }

    function renderOptions(product, variant) {
      optionsContainer.innerHTML = '';
      selectedOptions = variant && Array.isArray(variant.options) ? variant.options.slice() : [];

      if (!hasSelectableOptions(product)) {
        optionsContainer.hidden = true;
        return;
      }

      optionsContainer.hidden = false;

      getOptionGroups(product).forEach(function (group) {
        var fieldset = document.createElement('fieldset');
        var legend = document.createElement('legend');
        var values = document.createElement('div');

        fieldset.className = 'variant-option quick-view__option';
        fieldset.setAttribute('data-quick-view-option-group', '');
        fieldset.setAttribute('data-option-index', String(group.index));

        legend.className = 'variant-option__name';
        legend.textContent = group.name;
        fieldset.appendChild(legend);

        values.className = 'variant-option__values';

        group.values.forEach(function (value, valueIndex) {
          var input = document.createElement('input');
          var label = document.createElement('label');
          var id = 'QuickView-' + product.id + '-' + group.index + '-' + valueIndex;

          input.type = 'radio';
          input.id = id;
          input.name = 'QuickViewOption-' + group.index;
          input.value = value;
          input.checked = selectedOptions[group.index] === value;
          input.setAttribute('data-quick-view-option', '');
          input.setAttribute('data-option-index', String(group.index));

          label.setAttribute('for', id);
          label.textContent = value;

          values.appendChild(input);
          values.appendChild(label);
        });

        fieldset.appendChild(values);
        optionsContainer.appendChild(fieldset);
      });
    }

    function refreshCartCount() {
      return fetchCart()
        .then(function (cart) {
          updateCartCount(cart);
          return cart;
        })
        .catch(function () {});
    }

    function setStatus(message, isError) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
      status.classList.toggle('is-unavailable', Boolean(isError));
    }

    function openQuickView(card) {
      var productJson = card.querySelector('[data-quick-view-product]');
      var selectedVariantId = card.getAttribute('data-selected-variant-id');

      if (!productJson) return;

      try {
        currentProduct = JSON.parse(productJson.textContent);
      } catch (error) {
        currentProduct = null;
      }

      if (!currentProduct) return;

      currentProduct.url = card.getAttribute('data-product-url') || currentProduct.url || (currentProduct.handle ? '/products/' + currentProduct.handle : '#');

      var variant = getVariants().find(function (item) {
        return String(item.id) === String(selectedVariantId);
      }) || getFirstPurchasableVariant(currentProduct);

      activeElement = document.activeElement;
      activeVariant = variant;

      if (title) title.textContent = currentProduct.title || '';

      if (quantityInput) {
        quantityInput.value = '1';
      }

      setStatus('', false);
      renderImages(currentProduct, variant);
      renderOptions(currentProduct, variant);
      syncSelectedOptions(variant);
      updateState();

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('quick-view-open');

      window.requestAnimationFrame(function () {
        if (dialog) dialog.focus();
      });
    }

    function closeQuickView() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('quick-view-open');
      setStatus('', false);

      if (activeElement && typeof activeElement.focus === 'function') {
        activeElement.focus();
      }
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      var card = event.target.closest('[data-quick-view-card]');
      if (!card) return;

      if (event.target.closest('form, button, input, select, textarea, [data-quick-view-ignore]')) {
        return;
      }

      var trigger = event.target.closest('[data-quick-view-trigger]');
      var inCardAction = event.target.closest('.product-card__action');

      if (inCardAction && !trigger) {
        return;
      }

      event.preventDefault();
      openQuickView(card);
    });

    modal.querySelectorAll('[data-quick-view-close]').forEach(function (button) {
      button.addEventListener('click', closeQuickView);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeQuickView();
      }
    });

    optionsContainer.addEventListener('change', function (event) {
      if (!event.target.matches('[data-quick-view-option]')) return;

      var index = Number(event.target.getAttribute('data-option-index'));
      selectedOptions[index] = event.target.value;
      setStatus('', false);
      updateState();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!activeVariant || !activeVariant.available || !submitButton) return;

      var routes = window.ConsensutsTheme && window.ConsensutsTheme.routes;
      var quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);

      submitButton.disabled = true;
      if (submitText) {
        submitText.textContent = submitButton.getAttribute('data-adding-text');
      }
      setStatus('', false);

      fetch(routeWithJson(routes && routes.cartAdd), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(activeVariant.id),
          quantity: quantity
        })
      })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) {
              throw payload;
            }
            return payload;
          });
        })
        .then(function () {
          return refreshCartCount();
        })
        .then(function (cart) {
          closeQuickView();
          document.dispatchEvent(new CustomEvent('consensuts:cart-open', {
            detail: {
              cart: cart
            }
          }));

          if (activeVariant) {
            submitButton.disabled = !activeVariant.available;
            if (submitText) {
              submitText.textContent = activeVariant.available
                ? submitButton.getAttribute('data-add-text')
                : submitButton.getAttribute('data-sold-out-text');
            }
          }
        })
        .catch(function (error) {
          var message = (error && (error.description || error.message)) || (status && status.getAttribute('data-error-text'));
          setStatus(message, true);
          submitButton.disabled = false;
          if (submitText) {
            submitText.textContent = submitButton.getAttribute('data-add-text');
          }
        });
    });
  }

  function initCartDrawer() {
    if (document.documentElement.dataset.cartDrawerInitialized === 'true') return;

    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    document.documentElement.dataset.cartDrawerInitialized = 'true';

    var panel = drawer.querySelector('[data-cart-drawer-panel]');
    var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
    var emptyState = drawer.querySelector('[data-cart-drawer-empty]');
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    var subtotal = drawer.querySelector('[data-cart-drawer-subtotal]');
    var discountRow = drawer.querySelector('[data-cart-drawer-discount-row]');
    var discount = drawer.querySelector('[data-cart-drawer-discount]');
    var total = drawer.querySelector('[data-cart-drawer-total]');
    var checkoutButton = drawer.querySelector('[name="checkout"]');
    var activeElement = null;
    var removeText = drawer.getAttribute('data-remove-text') || 'Remove';
    var decreaseText = drawer.getAttribute('data-decrease-text') || 'Decrease quantity';
    var increaseText = drawer.getAttribute('data-increase-text') || 'Increase quantity';
    var quantityText = drawer.getAttribute('data-quantity-text') || 'Quantity';

    function renderCartItem(item) {
      var image = normalizeCartItemImage(item.image);
      var options = getCartItemOptions(item);
      var optionHtml = options.length
        ? '<p class="cart-drawer__item-options">' + options.map(escapeHtml).join(' / ') + '</p>'
        : '';

      return [
        '<article class="cart-drawer__item" data-cart-drawer-item data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + escapeHtml(item.quantity) + '">',
        '<a class="cart-drawer__item-media" href="' + escapeHtml(item.url || '#') + '">',
        image
          ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product_title || item.title || '') + '" width="96" height="96" loading="lazy">'
          : '<span class="empty-state">No image</span>',
        '</a>',
        '<div class="cart-drawer__item-info">',
        '<h3 class="cart-drawer__item-title"><a href="' + escapeHtml(item.url || '#') + '">' + escapeHtml(item.product_title || item.title || '') + '</a></h3>',
        optionHtml,
        '<div class="cart-drawer__quantity" data-cart-drawer-quantity>',
        '<button type="button" data-cart-drawer-quantity-change="-1" aria-label="' + escapeHtml(decreaseText) + '">-</button>',
        '<input type="number" min="0" value="' + escapeHtml(item.quantity) + '" data-cart-drawer-quantity-input aria-label="' + escapeHtml(quantityText) + '">',
        '<button type="button" data-cart-drawer-quantity-change="1" aria-label="' + escapeHtml(increaseText) + '">+</button>',
        '</div>',
        '<button class="cart-drawer__remove" type="button" data-cart-drawer-remove>' + escapeHtml(removeText) + '</button>',
        '</div>',
        '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat) + '</p>',
        '</article>'
      ].join('');
    }

    function renderCart(cart) {
      var hasItems = Boolean(cart && cart.item_count > 0);

      updateCartCount(cart);
      updateCartTierPrompts(cart);
      drawer.classList.toggle('is-empty', !hasItems);
      if (emptyState) emptyState.hidden = hasItems;
      if (footer) footer.hidden = !hasItems;
      if (checkoutButton) checkoutButton.disabled = !hasItems;

      if (!hasItems) {
        itemsContainer.innerHTML = '';
        if (subtotal) subtotal.textContent = formatMoney(0, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat);
        if (total) total.textContent = formatMoney(0, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat);
        if (discountRow) discountRow.hidden = true;
        return;
      }

      itemsContainer.innerHTML = cart.items.map(renderCartItem).join('');

      var subtotalPrice = getCartSubtotalPrice(cart);
      if (subtotal) subtotal.textContent = formatMoney(subtotalPrice, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat);
      if (total) total.textContent = formatMoney(cart.total_price, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat);

      if (discountRow && discount) {
        var discountValue = getCartDiscountValue(cart);
        discountRow.hidden = discountValue <= 0;
        discount.textContent = discountValue > 0
          ? '- ' + formatMoney(discountValue, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat)
          : '';
      }
    }

    function setLoading(loading) {
      drawer.classList.toggle('is-loading', loading);
      drawer.querySelectorAll('button, input').forEach(function (control) {
        if (control.hasAttribute('data-cart-drawer-close') || control.name === 'checkout') return;
        control.disabled = loading;
      });
    }

    function changeCartItem(key, quantity) {
      var routes = getCartRoutes();
      if (!routes.cartChange) return Promise.reject(new Error('Cart change route is missing.'));

      setLoading(true);

      return fetch(routeWithJson(routes.cartChange), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: Math.max(0, Number(quantity) || 0)
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed.');
          return response.json();
        })
        .then(function (cart) {
          renderCart(cart);
          document.dispatchEvent(new CustomEvent('consensuts:cart-sync', {
            detail: {
              cart: cart
            }
          }));
          return cart;
        })
        .finally(function () {
          setLoading(false);
        });
    }

    function openCartDrawer(cart) {
      activeElement = document.activeElement;

      var cartPromise = cart ? Promise.resolve(cart) : fetchCart();

      cartPromise
        .then(renderCart)
        .catch(function () {})
        .finally(function () {
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('cart-drawer-open');

          window.requestAnimationFrame(function () {
            if (panel) panel.focus();
          });
        });
    }

    function closeCartDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cart-drawer-open');

      if (activeElement && typeof activeElement.focus === 'function') {
        activeElement.focus();
      }
    }

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (button) {
      button.addEventListener('click', closeCartDrawer);
    });

    document.addEventListener('consensuts:cart-open', function (event) {
      openCartDrawer(event.detail && event.detail.cart);
    });

    document.addEventListener('consensuts:cart-sync', function (event) {
      if (event.detail && event.detail.cart) {
        renderCart(event.detail.cart);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });

    itemsContainer.addEventListener('click', function (event) {
      var item = event.target.closest('[data-cart-drawer-item]');
      if (!item) return;

      var key = item.getAttribute('data-line-key');
      var currentQuantity = Number(item.getAttribute('data-quantity')) || 0;
      var quantityButton = event.target.closest('[data-cart-drawer-quantity-change]');
      var removeButton = event.target.closest('[data-cart-drawer-remove]');

      if (quantityButton) {
        changeCartItem(key, currentQuantity + Number(quantityButton.getAttribute('data-cart-drawer-quantity-change')));
      } else if (removeButton) {
        changeCartItem(key, 0);
      }
    });

    itemsContainer.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-drawer-quantity-input]');
      if (!input) return;

      var item = input.closest('[data-cart-drawer-item]');
      if (!item) return;

      changeCartItem(item.getAttribute('data-line-key'), input.value);
    });
  }

  function initCartPage(root) {
    root.querySelectorAll('[data-cart-page]').forEach(function (cartPage) {
      if (cartPage.dataset.cartPageInitialized === 'true') return;
      cartPage.dataset.cartPageInitialized = 'true';

      var form = cartPage.querySelector('[data-cart-page-form]');
      var itemsContainer = cartPage.querySelector('[data-cart-page-items]');
      var emptyState = cartPage.querySelector('[data-cart-page-empty]');
      var footer = cartPage.querySelector('[data-cart-page-footer]');
      var subtotal = cartPage.querySelector('[data-cart-page-subtotal]');
      var discountRow = cartPage.querySelector('[data-cart-page-discount-row]');
      var discount = cartPage.querySelector('[data-cart-page-discount]');
      var total = cartPage.querySelector('[data-cart-page-total]');
      var checkoutButton = cartPage.querySelector('[name="checkout"]');
      var updateButton = cartPage.querySelector('[name="update"]');
      var removeText = document.querySelector('[data-cart-drawer]') && document.querySelector('[data-cart-drawer]').getAttribute('data-remove-text') || 'Remove';
      var decreaseText = document.querySelector('[data-cart-drawer]') && document.querySelector('[data-cart-drawer]').getAttribute('data-decrease-text') || 'Decrease quantity';
      var increaseText = document.querySelector('[data-cart-drawer]') && document.querySelector('[data-cart-drawer]').getAttribute('data-increase-text') || 'Increase quantity';
      var quantityText = document.querySelector('[data-cart-drawer]') && document.querySelector('[data-cart-drawer]').getAttribute('data-quantity-text') || 'Quantity';

      if (!form || !itemsContainer) return;

      function renderCartPageItem(item, index) {
        var image = normalizeCartItemImage(item.image);
        var options = getCartItemOptions(item);
        var optionHtml = options.length
          ? '<p class="cart-item__options">' + options.map(escapeHtml).join(' / ') + '</p>'
          : '';

        return [
          '<div class="cart-item" data-cart-page-item data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + escapeHtml(item.quantity) + '">',
          '<a class="cart-item__media" href="' + escapeHtml(item.url || '#') + '">',
          image
            ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product_title || item.title || '') + '" width="240" height="240" loading="lazy">'
            : '<div class="empty-state">No image</div>',
          '</a>',
          '<div>',
          '<h2 class="cart-item__title"><a href="' + escapeHtml(item.url || '#') + '">' + escapeHtml(item.product_title || item.title || '') + '</a></h2>',
          optionHtml,
          '<p class="cart-item__price">' + formatMoney(item.final_price || item.price || 0, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat) + '</p>',
          '<button class="footer-link cart-item__remove" type="button" data-cart-page-remove>' + escapeHtml(removeText) + '</button>',
          '</div>',
          '<div class="cart-item__total">',
          '<div class="quantity">',
          '<label class="visually-hidden" for="CartQuantityDynamic-' + index + '">' + escapeHtml(quantityText) + '</label>',
          '<div class="quantity__control">',
          '<button class="quantity__button" type="button" data-cart-page-quantity-change="-1" aria-label="' + escapeHtml(decreaseText) + '">-</button>',
          '<input class="quantity__input" id="CartQuantityDynamic-' + index + '" type="number" name="updates[]" min="0" value="' + escapeHtml(item.quantity) + '" data-cart-page-quantity-input>',
          '<button class="quantity__button" type="button" data-cart-page-quantity-change="1" aria-label="' + escapeHtml(increaseText) + '">+</button>',
          '</div>',
          '</div>',
          '<p class="price__sale" data-cart-page-line-price>' + formatMoney(item.final_line_price || 0, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat) + '</p>',
          '</div>',
          '</div>'
        ].join('');
      }

      function renderCartPage(cart) {
        var hasItems = Boolean(cart && cart.item_count > 0);

        updateCartCount(cart);
        updateCartTierPrompts(cart);

        if (emptyState) emptyState.hidden = hasItems;
        if (form) form.hidden = !hasItems;
        if (footer) footer.hidden = !hasItems;
        if (checkoutButton) checkoutButton.disabled = !hasItems;
        if (updateButton) updateButton.disabled = !hasItems;

        if (!hasItems) {
          itemsContainer.innerHTML = '';
          if (subtotal) subtotal.textContent = formatMoney(0, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat);
          if (total) total.textContent = formatMoney(0, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat);
          if (discountRow) discountRow.hidden = true;
          return;
        }

        itemsContainer.innerHTML = cart.items.map(renderCartPageItem).join('');

        if (subtotal) subtotal.textContent = formatMoney(getCartSubtotalPrice(cart), window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat);
        if (total) total.textContent = formatMoney(cart.total_price, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat);

        if (discountRow && discount) {
          var discountValue = getCartDiscountValue(cart);
          discountRow.hidden = discountValue <= 0;
          discount.textContent = discountValue > 0
            ? '- ' + formatMoney(discountValue, window.ConsensutsTheme && window.ConsensutsTheme.moneyFormat)
            : '';
        }
      }

      function setLoading(loading) {
        cartPage.classList.toggle('is-loading', loading);
        cartPage.querySelectorAll('[data-cart-page-quantity-change], [data-cart-page-quantity-input], [data-cart-page-remove], [name="update"]').forEach(function (control) {
          control.disabled = loading;
        });
      }

      function changeCartPageItem(key, quantity) {
        var routes = getCartRoutes();
        if (!routes.cartChange) return Promise.reject(new Error('Cart change route is missing.'));

        setLoading(true);

        return fetch(routeWithJson(routes.cartChange), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: Math.max(0, Number(quantity) || 0)
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart update failed.');
            return response.json();
          })
          .then(function (cart) {
            renderCartPage(cart);
            document.dispatchEvent(new CustomEvent('consensuts:cart-sync', {
              detail: {
                cart: cart
              }
            }));
            return cart;
          })
          .finally(function () {
            setLoading(false);
          });
      }

      itemsContainer.addEventListener('click', function (event) {
        var item = event.target.closest('[data-cart-page-item]');
        if (!item) return;

        var key = item.getAttribute('data-line-key');
        var currentQuantity = Number(item.getAttribute('data-quantity')) || 0;
        var quantityButton = event.target.closest('[data-cart-page-quantity-change]');
        var removeButton = event.target.closest('[data-cart-page-remove]');

        if (quantityButton) {
          changeCartPageItem(key, currentQuantity + Number(quantityButton.getAttribute('data-cart-page-quantity-change')));
        } else if (removeButton) {
          changeCartPageItem(key, 0);
        }
      });

      itemsContainer.addEventListener('change', function (event) {
        var input = event.target.closest('[data-cart-page-quantity-input]');
        if (!input) return;

        var item = input.closest('[data-cart-page-item]');
        if (!item) return;

        changeCartPageItem(item.getAttribute('data-line-key'), input.value);
      });

      form.addEventListener('submit', function (event) {
        if (event.submitter && event.submitter.name === 'checkout') return;
        event.preventDefault();
        fetchCart().then(renderCartPage);
      });

      document.addEventListener('consensuts:cart-sync', function (event) {
        if (event.detail && event.detail.cart) {
          renderCartPage(event.detail.cart);
        }
      });

      fetchCart().then(renderCartPage).catch(function () {});
    });
  }

  function initHeaders(root) {
    if (root.matches && root.matches('[data-site-header]')) {
      initHeader(root);
    }
    root.querySelectorAll('[data-site-header]').forEach(initHeader);
  }

  function initAnnouncementBars(root) {
    if (root.matches && root.matches('[data-announcement]')) {
      initAnnouncements(root);
    }
    root.querySelectorAll('[data-announcement]').forEach(initAnnouncements);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeaders(document);
    initAnnouncementBars(document);
    initHomeSlideshows(document);
    initSliders(document);
    initGallery(document);
    initQuantity(document);
    initProductForms(document);
    initVisitorBadges(document);
    initStickyATC(document);
    initQuickView();
    initCartDrawer();
    initCartPage(document);
    window.addEventListener('resize', syncFixedBars);
    window.requestAnimationFrame(syncFixedBars);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initHeaders(event.target);
    initAnnouncementBars(event.target);
    initHomeSlideshows(event.target);
    initSliders(event.target);
    initGallery(event.target);
    initQuantity(event.target);
    initProductForms(event.target);
    initVisitorBadges(event.target);
    initStickyATC(event.target);
    initQuickView();
    initCartDrawer();
    initCartPage(event.target);
    window.requestAnimationFrame(syncFixedBars);
  });
})();
